var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvmedLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 60,
    viewBox: "0 0 116 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AvMed Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M92.4791 32.5205C92.4791 33.335 92.3101 33.8706 92.2376 34.5309H77.4374C78.1215 36.5707 80.222 37.8548 82.4996 37.8548C84.0448 37.8548 85.7349 37.3558 86.7328 36.3506H91.795C90.6602 39.5204 86.5316 41.9344 82.6364 41.9344C77.1638 41.9344 72.5845 37.8841 72.5845 32.7993C72.5845 27.4944 77.2362 23.4148 82.6766 23.4148C88.0688 23.4148 92.4791 27.6191 92.4791 32.5205ZM77.365 30.8255H87.8676C87.2157 28.8518 85.0427 27.5017 82.6686 27.5017C80.2864 27.4944 78.0491 28.8811 77.365 30.8255Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M115.191 18.1758V41.3693H110.989V38.9846C109.686 40.6135 107.585 41.9343 104.583 41.9343C99.0061 41.9343 95.1108 37.4144 95.1108 32.7405C95.1108 27.7217 99.3763 23.422 104.712 23.422C106.982 23.422 109.291 24.3319 110.603 25.8067V18.1758H115.191ZM99.6982 32.6084C99.6982 35.6241 102.249 37.8473 105.308 37.8473C108.374 37.8473 110.917 35.5214 110.917 32.6378C110.917 29.8129 108.269 27.4943 105.235 27.4943C102.072 27.4943 99.6982 30.0404 99.6982 32.6084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.81853 18.095H14.7358L24.5302 41.3105H19.4922L17.4963 36.5265H7.10637L5.03803 41.3105H0L9.81853 18.095ZM12.3054 24.251L8.89302 32.2195H15.7016L12.3054 24.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.5605 24.1411H26.3813L31.1376 34.2741L35.886 24.1411H40.6745L32.6587 41.3106H29.5924L21.5605 24.1411Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M45.0846 18.095H49.8007L55.7079 34.2886L61.6634 18.095H66.3796L70.653 41.3105H65.9691L63.2409 26.6504L57.8246 41.3105H53.5591L48.1911 26.6504L45.3985 41.3105H40.6743L45.0846 18.095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M58.4927 4.09529C70.5647 4.05127 79.6106 10.0166 83.8519 19.0342C85.9846 19.4892 88.6002 20.986 89.9845 22.292C90.0167 22.3214 90.0408 22.3434 90.0649 22.3727C86.9182 10.0899 74.5082 0.918213 59.6677 0.918213C33.7533 0.918213 29.3027 22.2553 29.3027 22.2553C29.3027 22.2553 34.88 4.18334 58.4927 4.09529Z",
    fill: "#FFE558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.3868 45.7129C40.8756 52.3679 48.996 56.8144 59.2571 56.8144C69.9207 56.8144 81.1718 52.4046 86.5881 45.2947L86.5639 45.3167C80.874 54.0409 70.2185 59.9181 58.0097 59.9181C45.4066 59.9181 34.4613 53.6593 28.9243 44.4656C28.9565 44.4803 28.9807 44.4949 29.0128 44.5096C32.0791 45.8157 35.3868 45.7129 35.3868 45.7129Z",
    fill: "#FFE558"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvmedLogo);
export default __webpack_public_path__ + "static/media/avmed_logo.de9369ccd34667c332405dd9bd021b7b.svg";
export { ForwardRef as ReactComponent };